module.exports = __webpack_public_path__ + "static/img/attribute-table-add.145b5269.svg";